<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Program List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-1">
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="programCreate"
                >Create</CButton
              >
            </CCol>
            <CCol col="2">
              <CSelect
                :options="optionsCountry"
                required
                v-model="selectedCountry"
                @change="handleCountry"
              />
            </CCol>
            <CCol col="2">
              <CSelect
                :options="filteredLanguageOptions"
                required
                v-model="selectedLanguage"
                :disabled="selectedCountry === 'malaysia'"
                @change="handleLanguage"
              />
            </CCol>
            <CCol class="float-right" col="3">
              <div class="search-list">
                <CInput
                  class="float-left mb-0 mr-2"
                  placeholder="Search By Nama Program"
                  @input="handleSearch($event)"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </div>
            </CCol>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="activePage"
            :pagination="{ doubleArrows: false, align: 'center' }"
            @page-change="pageChange"
          >
            <template #program_type="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="rowClicked(data.item.program_id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="handlePage('REFRESH');"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="handlePage('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="handlePage('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "Program",
  data() {
    return {
      items: [],
      fields: [
        { key: "program_id", label: "ID" },
        { key: "program_name", label: "Nama Program" },
        { key: "active_date" },
        { key: "status" },
        { key: "program_type", label: "Action" },
      ],
      activePage: 1,
      selectedLanguage: "",
      selectedCountry: "",
      optionsLanguage: [
        { label: "Select Language", value: "" },
        { label: "Indonesia", value: "ID" },
        { label: "English", value: "EN" },
      ],
      optionsCountry: [
        { label: "Select Country", value: "" },
        { label: "Indonesia", value: "indonesia" },
        { label: "Malaysia", value: "malaysia" },
      ],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      q: "",
    };
  },
  mounted() {
    this.authentication();
    this.searchProgram("", "");
  },
  watch: {
    selectedCountry(newVal) {
      if (newVal === "malaysia") {
        this.selectedLanguage = "EN";
        this.searchProgram(this.q, 'REFRESH', this.selectedLanguage, this.selectedCountry)
      }
    }
  },
  computed: {
    filteredLanguageOptions() {
      if (this.selectedCountry === "malaysia") {
        return [{ label: "English", value: "EN" }];
      }

      return this.optionsLanguage;
    }
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    handleSearch(event) {
      this.q = event;
      this.searchProgram(this.q, 'REFRESH')
    },
    handleLanguage(event) {
      this.selectedLanguage = event.target.value;
      this.searchProgram(this.q, 'REFRESH', this.selectedLanguage)
    },
    handleCountry(event) {
      this.selectedCountry = event.target.value;

      if (this.selectedCountry === "malaysia") {
        this.selectedLanguage = "EN";
      }

      this.searchProgram(this.q, 'REFRESH', this.selectedLanguage, this.selectedCountry)
    },
    handlePage(event) {
      this.searchProgram(this.q, event)
    },
    searchProgram(query = this.q, action, lang = this.selectedLanguage, country = this.selectedCountry) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/program/data?page=${this.activePage}&per_page=20&lang=${lang}&country=${country}&q=${query}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data?.data?.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
            this.items.forEach((element) => {
              element.active_date = moment(String(element.active_date)).format(
                "MM/DD/YYYY HH:mm"
              );
            });
          } else {
            if (action === "NEXT") {
              this.activePage = this.activePage - 1;
            }
            else {
              this.items = []
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/program/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    programCreate() {
      this.$router.push({ path: `/management/program/create` });
    },
  },
};
</script>

<style scoped>
@import "./Program.css";
</style>
